const getCategoriesOptions = (categories = []) => {
  return categories.map((item) => {
    return {
      label: item.title,
      value: item.id,
    };
  });
};

export default getCategoriesOptions;
